class ServiceCart {
  constructor(id, items, price, fee, priceWithFee) {
    this.id = id;
    this.items = items;
    this.price = price;
    this.fee = fee;
    this.priceWithFee = priceWithFee;
  }
}

export default ServiceCart;
